<script lang="ts" setup>
    import GlobalSearchItem from '@/app/common/models/GlobalSearchItem';

    const props = defineProps<{
        result: GlobalSearchItem;
    }>();
</script>

<template>
    <AppSearchModalResult
        :icon="result.invoice.faIcon"
        :result="result"
        :icon-tooltip="$t(`invoice_document_type.${result.invoice.invoiceType}`)"
    >
        <template v-slot>
            <span class="block text-sm text-gray-800"> {{ result.invoice.numberOrDraft }} - {{ $price(result.invoice.total) }} </span>
            <span class="block text-xs text-gray-600">
                {{ result.invoice.trueDate?.toEUDateString() }}
                <span v-if="result.contact"> - {{ result.contact?.displayName }} </span>
            </span>
        </template>
        <template v-slot:right>
            <InvoicingInvoiceStatusBadge
                :invoice="result.invoice"
                size="px-3 py-2 text-xs min-w-[85px]"
            />
        </template>
    </AppSearchModalResult>
</template>
